// @ts-nocheck
/* eslint-enable */
import React from 'react';
import PropTypes from 'prop-types';
import take from 'lodash/take';
import drop from 'lodash/drop';

import Title from 'app/shared/modules/Title';
import AreaCard from 'app/shared/modules/state-page/AreaCard';
import LinkToggle from 'app/shared/modules/LinkToggle';
import Container from 'app/shared/core/Container';
import Center from 'app/shared/modules/Center';
import Row from 'app/shared/core/Row';

import 'app/shared/modules/state-page/AreaCardList.scss';
import { generateCitySitemapUrlFromResourceId, isCitySitemapEnabled } from 'app/shared/utils/cityUtils';

const MAX_VISIBLE_LESS = 12;
const MAX_VISIBLE_MORE = 50;

// Helper function to generate city link data
const getCityLinkData = (area, isCitiesSection, stateAbbreviation) => {
  const showCityLink = isCitiesSection && area.resourceId && isCitySitemapEnabled(stateAbbreviation);
  return {
    showCityLink,
    citySitemapLink: showCityLink ? generateCitySitemapUrlFromResourceId(area.resourceId) : '',
    srpLinkText: showCityLink ? `${area.listingCount} Newest Apartments for Rent ${area.name}` : '',
  };
};

class AreaCardList extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    areas: PropTypes.array,
  };

  constructor(props) {
    super(props);
    const { title } = props;
    this.state = {
      visible: MAX_VISIBLE_LESS,
      showLinkText: `View more ${title.toLowerCase()}`,
    };
  }

  handleViewToggleClick = () => {
    const { title } = this.props;
    if (this.state.visible === MAX_VISIBLE_LESS) {
      this.setState({
        visible: MAX_VISIBLE_MORE,
        showLinkText: `View less ${title.toLowerCase()}`,
      });
    } else {
      this.setState({
        visible: MAX_VISIBLE_LESS,
        showLinkText: `View more ${title.toLowerCase()}`,
      });
    }
  };

  render() {
    let { areas } = this.props;
    const { title, stateName, stateAbbreviation } = this.props;
    const { visible } = this.state;
    const showToggle = areas.length > MAX_VISIBLE_LESS;
    const areasLeft = visible === MAX_VISIBLE_MORE ? [] : take(drop(areas, visible), MAX_VISIBLE_MORE - visible);
    areas = take(areas, visible);

    const isCitiesSection = title && title.toLowerCase().includes('cities');

    return (
      <Container className="AreaCardList">
        <Row size="lg">
          <Title htmlTag="h2" size="lg">
            {title}
          </Title>
        </Row>
        <div className="AreaCardList-cards">
          {areas.map((area, index) => {
            const { showCityLink, citySitemapLink, srpLinkText } = getCityLinkData(
              area,
              isCitiesSection,
              stateAbbreviation,
            );

            return (
              <AreaCard
                key={`AreaCard${area.id || area.name || index}`}
                name={area.name}
                link={area.uriV2}
                phrase={area.phrase}
                showCitySitemapLink={showCityLink}
                citySitemapLink={citySitemapLink}
                srpLinkText={srpLinkText}
              />
            );
          })}
          {areasLeft.map((area, index) => {
            const { showCityLink, citySitemapLink, srpLinkText } = getCityLinkData(
              area,
              isCitiesSection,
              stateAbbreviation,
            );

            return (
              <AreaCard
                key={`AreaCardHidden${area.id || area.name || index}`}
                name={area.name}
                link={area.uriV2}
                phrase={area.phrase}
                hidden
                showCitySitemapLink={showCityLink}
                citySitemapLink={citySitemapLink}
                srpLinkText={srpLinkText}
              />
            );
          })}
        </div>
        {showToggle && (
          <Center>
            <Row>
              <LinkToggle onClick={this.handleViewToggleClick}>{this.state.showLinkText}</LinkToggle>
            </Row>
          </Center>
        )}
      </Container>
    );
  }
}

export default AreaCardList;
